module.exports = __webpack_public_path__ + "img/15.4b56c09c.jpeg";